const SUPABASE_URL = import.meta.env.VITE_SUPABASE_URL as string;

const BRANDED_HOSTS = ["wavai.ae", "www.wavai.ae", "faisalkarkoh.com", "www.faisalkarkoh.com"];

export function resolveAssetUrl(url?: string | null): string {
  if (!url) return "";
  if (url.startsWith("/")) return url;

  try {
    const parsed = new URL(url);

    // Branded domain with /storage/ path → rewrite to direct Supabase URL
    if (BRANDED_HOSTS.includes(parsed.hostname) && parsed.pathname.startsWith("/storage/")) {
      const publicObjectPath = parsed.pathname.replace(/^\/storage\//, "");
      return `${SUPABASE_URL}/storage/v1/object/public/${publicObjectPath}${parsed.search}`;
    }

    return url;
  } catch {
    return url;
  }
}
